import React from "react";

function OfflineRequest() {
  return <div>OfflineRequest</div>;
}

export default OfflineRequest;
